interface OAuthWaitingStateProps {
  /** Tailwind background class for the pulsing check circle (e.g. "bg-green-100"). */
  iconBgClass: string;
  /** Tailwind text color class for the check icon (e.g. "text-green-600"). */
  iconColorClass: string;
}

/**
 * "Waiting for authorization…" state shown while an OAuth popup is open and we
 * poll for the callback (Slack, Zoom). The accent color is provider-specific.
 */
export function OAuthWaitingState({
  iconBgClass,
  iconColorClass,
}: OAuthWaitingStateProps) {
  return (
    <div className="text-center py-8">
      <div className="animate-pulse">
        <div className={`h-12 w-12 ${iconBgClass} rounded-full flex items-center justify-center mx-auto mb-4`}>
          <svg
            className={`w-6 h-6 ${iconColorClass}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
      </div>
      <p className="text-sm text-gray-600">
        Waiting for authorization...
      </p>
      <p className="text-xs text-gray-500 mt-1">
        Please complete the authorization in the popup window
      </p>
    </div>
  );
}
